import type { Post } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/PostsWrapper/types';
import { getLinkUrlToPostItem } from 'hb-react/frontoffice/apps/LiveFeed/utils/getLinkUrlToPostItem';
import { APP_TYPE } from 'hb-react/types/appType';

export interface PostSliderItem {
  avatarUrl: Post['photo_thumb_url'];
  canEdit: boolean;
  content: string;
  href: string;
  id: Post['id'];
  index: number;
  likes: { count: Post['likes_count'] };
  openModal: () => void;
  publishedAt: Post['published_at'];
  totalComment: Post['comments_count'];
  userId: Post['user_id'];
}

export const mapPosts = ({
  app,
  posts,
  topicId,
}: {
  app: APP_TYPE;
  posts: Post[];
  topicId?: number | null;
}): PostSliderItem[] =>
  posts?.map(
    (
      {
        comments_count: commentCount,
        content,
        id,
        likes_count: likesCount,
        photo_thumb_url: avatarUrl,
        published_at: publishedAt,
        user_id: userId,
      },
      index,
    ) => {
      const type = 'posts_feed_post';
      const showGoBackButton = false;

      const href =
        app === APP_TYPE.BACKOFFICE
          ? '#'
          : getLinkUrlToPostItem(type, id, { showGoBackButton, topicId });

      const handleOpenModal = () =>
        // @TODO ADD LATER A DELETE POST
        null;

      return {
        avatarUrl,
        canEdit: false,
        content,
        href,
        id,
        index,
        likes: { count: likesCount },
        openModal: handleOpenModal,
        publishedAt,
        totalComment: commentCount,
        userId,
      };
    },
  );
